<template>
  <i
    style="font-size: 18px; color: rgba(41, 204, 167, 1)"
    class="iconsax"
    icon-name="tick-square"
  ></i>
</template>
